import React from "react";
import Footer from "./Footer";

export default function Layout({ children }, props) {
  return (
    <>
      <main>{children}</main>
      <Footer />
    </>
  );
}
